export type UploadedFile = {
  name: string;
  fileType: string;
  uploadedFileId: string;
};

export enum Page {
  SubjectSelection = 1,
  LessonIntentSelection = 2,
  LessonGoals = 3,
  Generate = 4,
}
